import { triggerHaptic } from './haptics'

/**
 * Vue directive to automatically add haptic feedback to primary buttons
 * Usage: v-haptic or v-haptic="'medium'"
 * 
 * Automatically detects primary buttons by checking for common primary button classes:
 * - primary-cta-button
 * - bg-gold, bg-emerald-600, bg-blue-500, bg-indigo-600
 * - bg-gradient-to-r (gradient buttons)
 * - action-button
 */
export const hapticDirective = {
  mounted(el, binding) {
    // Check if element is a button or has button-like classes
    const isButton = el.tagName === 'BUTTON' || el.tagName === 'A' || el.getAttribute('role') === 'button'
    
    // Check for primary button indicators
    const classList = el.className || ''
    const isPrimaryButton = 
      classList.includes('primary-cta-button') ||
      classList.includes('action-button') ||
      classList.includes('bg-gold') ||
      classList.includes('bg-emerald-600') ||
      classList.includes('bg-emerald-700') ||
      classList.includes('bg-blue-500') ||
      classList.includes('bg-blue-600') ||
      classList.includes('bg-indigo-600') ||
      classList.includes('bg-gradient-to-r') ||
      (classList.includes('bg-') && (classList.includes('text-white') || classList.includes('font-bold')))
    
    // Only apply to buttons that appear to be primary actions
    if (isButton && isPrimaryButton) {
      const hapticType = binding.value || 'light'
      
      const handleClick = (e) => {
        triggerHaptic(hapticType)
      }
      
      el.addEventListener('click', handleClick)
      el._hapticHandler = handleClick
    }
  },
  
  unmounted(el) {
    if (el._hapticHandler) {
      el.removeEventListener('click', el._hapticHandler)
      delete el._hapticHandler
    }
  }
}


